import Card from './ui/Card';
import Icon from './ui/Icon';
import Reveal from './ui/Reveal';
import { approachPillars } from '../data/content';

export default function Approach() {
  return (
    <section className="navy-sec" id="approach">
      <div className="wrap center">
        <Reveal as="span" className="eyebrow">
          The approach
        </Reveal>

        <Reveal as="h2" className="h-sec">
          Confidence isn&rsquo;t memorized.
          <br />
          <span
            style={{
              background: 'linear-gradient(120deg,#7fd4ff,#bfeaff)',
              WebkitBackgroundClip: 'text',
              backgroundClip: 'text',
              color: 'transparent',
            }}
          >
            It&rsquo;s developed.
          </span>
        </Reveal>

        <Reveal as="p" className="lede narrow mt-m" style={{ marginInline: 'auto' }}>
          LNG Ready is designed to help you build the technical judgment, confidence, and
          decision-making skills that distinguish high-performing LNG professionals — through
          coaching, practical application, and expert guidance.
        </Reveal>

        <div className="grid4 mt-l">
          {approachPillars.map((pillar, i) => (
            <Reveal key={pillar.title} delay={i % 4}>
              <Card>
                <div className="ic-tile ic-center">
                  <Icon name={pillar.icon} />
                </div>
                <h4>{pillar.title}</h4>
                <p>{pillar.body}</p>
              </Card>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-l">
          <a className="btn btn-white btn-lg" href="#pricing">
            Join the Program
          </a>
        </Reveal>
      </div>
    </section>
  );
}
